import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const Background = superstyled({
  name: 'StandaloneHeaderBackground',
  slot: 'Background',
  tag: Box,
  styles: () => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    zIndex: 10,
    background: `linear-gradient(90deg, #111112 0%, #1B2845 100%)`
  })
});

export const Root = superstyled({
  name: 'StandaloneHeaderRoot',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    maxWidth: '67rem',
    width: `calc(100vw - ${theme.spacing(4)})`,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    paddingBlock: theme.spacing(2),
    gap: theme.spacing(2),
    color: theme.palette.text.white,
    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(3),
      alignItems: 'center',
      flexDirection: 'row',
      paddingBlock: theme.spacing(2),
      width: `calc(100vw - ${theme.spacing(8)})`
    }
  })
});

export const LogoContainer = superstyled({
  name: 'StandaloneHeaderLogoContainer',
  slot: 'LogoContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexShrink: 0,
    paddingRight: theme.spacing(3),
    borderRight: '1px solid rgba(255, 255, 255, 0.2)',
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(2),
      borderRight: 'none'
    }
  })
});

export const ContentContainer = superstyled({
  name: 'StandaloneHeaderContentContainer',
  slot: 'ContentContainer',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: 1,
    minWidth: 0,
    gap: theme.spacing(0.25)
  })
});

export const Title = superstyled({
  name: 'StandaloneHeaderTitle',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.text.white,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%'
  })
});

export const Subtitle = superstyled({
  name: 'StandaloneHeaderSubtitle',
  slot: 'Subtitle',
  tag: Text,
  styles: () => ({
    color: 'rgba(255, 255, 255, 0.7)',
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textWrap: 'wrap',
    maxWidth: '100%'
  })
});
